<template>
    <div>
        <div class="card">
            <div class="card-header">User Identity Verification (eKYC) - Optional, unless building family group</div>
            <div v-if="Status == 0 || Status == 4" class="card-body">
                <b v-if="Status == 4">
                    Your prvious submission was rejected, please resend with better images.
                </b>
                <form @submit.prevent="validateForm">
                    <div class="row">
                        <div class="col-sm-12 col-xl-4 col-form-label">
                            <div class="row">
                                <label class="col">Front of MyKad/MyKid</label>
                            </div>
                            <div class="form-group row">
                                <input id="IcFrontPhoto" type="file" v-validate="'required|mimes:image/*'" data-vv-as="front IC" name="IcFrontPhoto" ref="IcFrontPhoto" class="col col-12"
                                    :class="{'is-invalid':  validationErrors.has('IcFrontPhoto')}" @change="changeImageFile('IcFrontPhotoImgSrc', $event)">
                                <img class="col col-12 mt-2" :src="IcFrontPhotoImgSrc" />
                                <div v-show="validationErrors.has('IcFrontPhoto')" class="invalid-feedback col">
                                    {{ validationErrors.first('IcFrontPhoto') }}
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-12 col-xl-4 col-form-label">
                            <div class="row">
                                <label class="col">Back of MyKad/MyKid</label>
                            </div>
                            <div class="form-group row">
                                <input id="IcBackPhoto" type="file" v-validate="'required|mimes:image/*'" data-vv-as="back IC" name="IcBackPhoto" ref="IcBackPhoto" class="col col-12"
                                    :class="{'is-invalid':  validationErrors.has('IcBackPhoto')}" @change="changeImageFile('IcBackPhotoImgSrc', $event)">
                                <img class="col col-12 mt-2" :src="IcBackPhotoImgSrc" />
                                <div v-show="validationErrors.has('IcBackPhoto')" class="invalid-feedback col">
                                    {{ validationErrors.first('IcBackPhoto') }}
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-12 col-xl-4 col-form-label">
                            <div class="row">
                                <label class="col">Selfie with front of MyKad/MyKid</label>
                            </div>
                            <div class="form-group row">
                                <input id="IcSelfiePhoto" type="file" v-validate="'required|mimes:image/*'" data-vv-as="selfie with IC" name="IcSelfiePhoto" ref="IcSelfiePhoto" class="col col-12"
                                    :class="{'is-invalid':  validationErrors.has('IcSelfiePhoto')}" @change="changeImageFile('IcSelfiePhotoImgSrc', $event)">
                                <img class="col col-12 mt-2" :src="IcSelfiePhotoImgSrc" />
                                <div v-show="validationErrors.has('IcSelfiePhoto')" class="invalid-feedback col">
                                    {{ validationErrors.first('IcSelfiePhoto') }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <p v-show="isSubmitMessageShown" :class="{
                                'text-danger': isSubmitMessageError,
                                'mb-3': true
                            }">
                                {{message}}
                            </p>
                        </div>
                        <div class="col col-12">
                            <small class="mb-3">
                                Note: eKyc for MyKad/MyKid only.
                            </small>
                        </div>
                        <div class="col col-12">
                            <button class="btn btn-secondary mr-2" @click="clearFiles">Clear Files</button>
                            <button class="btn btn-primary btn-primary-insv" @click="uploadKycRequest" :disabled="isUploading">{{uploadButtonText}}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div v-if="Status == 1" class="card-body">
                Your verification request is being processed.
            </div>
            <div v-if="Status == 2" class="card-body">
                Your identity is verified and accepted.
            </div>
            <div v-if="Status == 3" class="card-body">
                Your identity verification is unsuccessful.
            </div>
        </div>
        <popup-modal ref="popupUpdateSuccessful" :hasCloseButton="false" title="Permission Update">
            <template slot="content">
                <p>Your uploaded photos will be removed from our system after eKYC internal processing. We will not saving them for other purposes in future. </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupSuccessful">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import 'daterangepicker/daterangepicker';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'ProfileVerification',
    'components': {
        popupModal
    },
    data () {
        return {
            'isSubmitMessageError': false,
            'IcFrontPhotoImgSrc': '',
            'IcBackPhotoImgSrc': '',
            'IcSelfiePhotoImgSrc': '',
            'Status': 0,
            'message': '',
            'isUploading': false
        };
    },
    'computed': {
        isSubmitMessageShown () {
            return this.message;
        },
        uploadButtonText () {
            if (this.isUploading) {
                return 'Please wait...';
            } else {
                return 'Upload Photos For eKYC';
            }
        }
    },
    mounted () {
        this.getKycRequestStatus();
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        changeImageFile (imgSrc, e) {
            this[imgSrc] = URL.createObjectURL(e.target.files[0]);
        },
        getKycRequestStatus () {
            this.axios.get('Kyc/GetKycStatus').then(({ data }) => {
                let kycStatus = data.data;

                this.Status = kycStatus.s;
            });
        },
        uploadKycRequest () {
            this.validateForm().then((isValidate) => {
                if (isValidate) {
                    let IcFrontPhoto = document.querySelector('#IcFrontPhoto');
                    let IcBackPhoto = document.querySelector('#IcBackPhoto');
                    let IcSelfiePhoto = document.querySelector('#IcSelfiePhoto');
                    let formData = new FormData();
                    formData.append('IcFrontPhoto', IcFrontPhoto.files[0]);
                    formData.append('IcBackPhoto', IcBackPhoto.files[0]);
                    formData.append('IcSelfiePhoto', IcSelfiePhoto.files[0]);
                    this.message = 'Sending verification request.';
                    this.isSubmitMessageError = false;
                    this.isUploading = true;
                    this.axios.post('Kyc/SendKycRequest', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({ data }) => {
                        this.message = 'Verification request sent successfully!';
                        this.isSubmitMessageError = false;
                        this.$refs.popupUpdateSuccessful.show();
                    }).catch(({ data }) => {
                        this.message = 'Error sending verification request. Please try again.';
                        this.isSubmitMessageError = true;
                    }).finally(() => {
                        this.isUploading = false;
                    });
                } else {
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s) before saving your invitation request.';
                }
            });
        },
        clearFiles () {
            this.$refs.IcFrontPhoto.value = null;
            this.$refs.IcBackPhoto.value = null;
            this.$refs.IcSelfiePhoto.value = null;

            this.IcFrontPhotoImgSrc = '';
            this.IcBackPhotoImgSrc = '';
            this.IcSelfiePhotoImgSrc = '';
        },
        dismissPopupSuccessful () {
            this.getKycRequestStatus();
            this.$refs.popupUpdateSuccessful.hide();
        }
    }
};
</script>
